export default __webpack_public_path__ + "static/media/login_9.6b6d3ba4.png";